// extracted by mini-css-extract-plugin
export default {"productGrid":"R1-z","centerLink":"S1-z","productSection":"T1-z","item":"U1-z","ctaButton":"V1-z"};